export default __webpack_public_path__ + "static/discover-ampm-en-eea9ea1d236d328c3d470556c7379313.svg";